import { FC, useState } from "react";

import clsx from "clsx";

import { QuestionComponentProps } from "../../../../../../../../model";

import st from "./Matching.module.scss";

type Props = QuestionComponentProps;

// todo change mobile view
export const Matching: FC<Props> = ({
  answers,
  userAnswer,
  setUserAnswer,
}) => {
  const userAnswerT: (number | null)[] = Array.isArray(userAnswer)? userAnswer: [];

  const middleIndex = Math.floor(answers.length / 2);
  const left = answers.slice(0, middleIndex);
  const right = answers.slice(middleIndex);
  const rows = Math.max(left.length, right.length);

  const [ selectedQuestion, setSelectedQuestion ] = useState<null | number>(null);

  const onClickQuestion = (index: number) => {
    setSelectedQuestion((prev) => (prev === index ? null : index));
  };

  const onClickAnswer = (rightIndex: number) => {
    if (selectedQuestion === null) return;
    const res = [ ...userAnswerT ];
    const prevLeftIndex = res.findIndex((r) => r === rightIndex);
    if (prevLeftIndex >= 0) {
      res[ prevLeftIndex ] = null;
    }
    res[ selectedQuestion ] = rightIndex;
    setUserAnswer(res);
    setSelectedQuestion(null);
  };

  const getIndex = (lib: (number | null)[], rightIndex: number) => {
    const leftIndex = lib.findIndex((r) => r === rightIndex);
    if (leftIndex === -1) return "";
    return leftIndex + 1;
  };

  return (
    <div className={st.wrap}>
      {
        Array.from({
          length: rows,
        }).map((_, i) => (
          <div
            key={i}
            className={st.row}
          >
            <button
              className={
                clsx(
                  st.item,
                  st.left_column_item,
                  i === selectedQuestion && st.selected,
                )
              }
              onClick={() => onClickQuestion(i)}
            >
              <span className={st.answer_index}>{i + 1}</span>
              <span>{left[ i ]}</span>
            </button>

            <button
              className={
                clsx(
                  st.item,
                  st.right_column_item,
                  selectedQuestion !== null && st.can_select,
                )
              }
              onClick={() => onClickAnswer(i)}
            >
              <span className={st.answer_index}>{getIndex(userAnswerT, i)}</span>
              <span>{right[ i ]}</span>
            </button>
          </div>
        ))
      }
    </div>
  );
};
